// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"52":"view-Login","160":"view-Index","212":"view-Score","670":"view-Detail","797":"view-ScoreForm"}[chunkId] + "." + {"52":"67c98600","160":"520a0369","212":"e1a41851","670":"58bd93e6","797":"918884e3"}[chunkId] + ".css";
};